module.exports = __webpack_public_path__ + "img/customerBlue.4b39bc8f.svg";